<template>
	<div class="detail">
		<div class="header">
			<div class="left" @click="goBack()">&lt; 返回</div>
			<div class="span1">
				<span>{{ flag == "add" ? "登记作业" : "修改登记作业" }}</span>
			</div>
			<div class="right"></div>
		</div>
		<div v-loading="loading">
			<el-form :inline="false" :model="addData" :rules="rules" label-width="260px" ref="formRef">
				<el-form-item label="选择科目" prop="subjectId">
					<el-select
						v-model="addData.subjectId"
						clearable
						placeholder="请选择"
						class="label"
						@change="subjectChange"
						:disabled="isDisabled"
					>
						<el-option
							v-for="item in SubjectList"
							:key="item.subjectId"
							:label="item.subjectName"
							:value="item.subjectId"
						>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="作业日期" prop="homeworkDate">
					<el-date-picker
						v-model="addData.homeworkDate"
						type="date"
						placeholder="选择日期"
						format="yyyy-MM-dd"
						class="label"
						:picker-options="pickerOptionsStart"
						@change="hwDateChange"
						:disabled="isDisabled"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="作业标题" prop="title">
					<el-input
						v-model="addData.title"
						placeholder="请输入"
						class="subLabel"
						@change="titleChange"
					></el-input>
				</el-form-item>
				<el-form-item label="作业内容" prop="content">
					<el-input
						type="textarea"
						resize="none"
						:rows="6"
						placeholder="请输入"
						v-model="addData.content"
						maxlength="1000"
						show-word-limit
						class="subLabel"
					></el-input>
				</el-form-item>
				<el-form-item label="作业附件">
					<label for="uploadBtn" class="pointer">
						<el-button
							type="primary"
							:loading="uploading"
							size="small"
							class="upload"
							@click="uploadBtnClick"
						>
							{{ uploading ? "上传中" : "本地上传" }}
						</el-button>

						<input
							type="file"
							accept="audio/*,video/*,image/*,.rar,.zip,.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt"
							:disabled="disableUpload"
							class="upload-input"
							ref="uploadInput"
							single
							@change="uploadFile()"
						/>
					</label>
					<span v-show="transcoding" class="transcoding">转码中...</span>
					<ul class="file-list">
						<li v-for="(item, i) in addData.resources" :key="i + '作业附件'" class="file-item">
							<div>
								<img :src="ShowImg(item.ext)" class="img-icon" />
								<span>{{ item.name }}</span>
							</div>

							<img src="./img/del.svg" alt="" class="del" @click="delFile(i)" />
						</li>
					</ul>
				</el-form-item>
				<el-form-item label="设计意图" prop="purpose">
					<el-input
						type="textarea"
						resize="none"
						:rows="4"
						placeholder="请输入"
						v-model="addData.purpose"
						maxlength="200"
						show-word-limit
						class="subLabel"
					></el-input>
				</el-form-item>
				<el-form-item label="选择班级" prop="classId">
					<el-input ref="hiddenInput" v-model="addData.classId" class="hidden-input"></el-input>
					<el-button type="text" @click="open" :disabled="isDisabled">+ 添加班级</el-button>
					<ul class="class-list">
						<li v-for="(item, i) in addData.classInfos" :key="item.id" class="class-item">
							{{ item.label }}
							<img
								src="./img/del.svg"
								@click="isDisabled ? '' : delClass(item, i)"
								:class="{ forbidden: isDisabled }"
							/>
						</li>
					</ul>
				</el-form-item>
				<el-form-item label="预计完成时长" prop="estimateDuration">
					<div class="minutes-box">
						<el-select
							v-model="addData.estimateDuration"
							clearable
							placeholder="请选择"
							@change="estimateChange"
							style="width:120px"
						>
							<el-option
								v-for="item in minutesList"
								:key="item.id"
								:label="item.label"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<el-input
							v-if="addData.estimateDuration === 'other'"
							v-model="addData.customMinutes"
							style="width:120px;margin-left:10px"
							type="number"
							max="120"
							min="5"
							@blur="timeLimit"
						></el-input>
						<p class="minutes-text">
							分钟<span v-if="addData.estimateDuration === 'other'"
								>（支持输入5-120分钟内数字）</span
							>
						</p>
					</div>
					<div class="minutes-bottom">
						<p v-show="selectedHwDate && addData.classInfos">
							{{ selectedHwDate }}日 已登记作业科目信息
						</p>
						<p v-for="item in classHwList" :key="item.id">
							<span>{{ item.label }}：</span>
							<span v-for="val in item.subjectList" :key="val.id"
								>{{ val.subjectName }}-{{ val.estimateDuration }}分钟&emsp;</span
							>
							<span class="minutes-red" v-if="item.isOutLimit">已超时</span>
							<span v-if="item.subjectList && !item.subjectList.length">暂未登记</span>
						</p>
					</div>
				</el-form-item>

				<el-form-item label="作业截止时间" prop="realDeadline">
					<div class="cls-title">
						<el-date-picker
							v-model="addData.deadline"
							name="deadline"
							type="datetime"
							placeholder="选择日期时间"
							value-format="yyyy-MM-dd HH:mm:ss"
							:default-value="
								dayjs()
									.set('hour', 23)
									.set('minute', 0)
									.set('second', 0)
									.toDate()
							"
							:align="'right'"
							:picker-options="pickerOptions"
							ref="deadline"
							@change="deadlineChange"
							:disabled="isDisabled"
						/>
					</div>
					<div v-show="showUnlimitedShade" class="unlimited-shade" @click="clickUnlimitedShade">
						{{ addData.realDeadline }}
					</div>
				</el-form-item>
			</el-form>

			<footer>
				<el-button
					style="width:120px;"
					:disabled="transcoding"
					type="primary"
					size=""
					@click="save()"
					>立即登记</el-button
				>
			</footer>
		</div>
		<SelectStuDialog
			:homeworkDate="addData.homeworkDate"
			:subjectId="addData.subjectId"
			:classInfos="addData.classInfos"
			:dialogVisible="showClassDialog"
			@confirm="confirm"
			@hideDialog="hideDialog"
		/>
	</div>
</template>
<script>
	import {
		addHwRegister,
		updateHwRegister,
		getClassHwList,
		getHwDetail,
	} from "@/api/school/index.js";
	import SelectStuDialog from "../components/selectClass/selectStuDialog.vue";
	import dayjs from "dayjs";
	import reqTip from "@/utils/requestTip";
	import UploadService from "@/utils/fileCenter/tencentCloud.upload";
	import util from "@/utils/util.js";
	import to from "@/utils/await-to";
	import axios from "axios";

	export default {
		components: { SelectStuDialog },
		data() {
			return {
				currSubject: "", //当前科目
				currDate: "", //当前日期
				transcoding: false, //视频文件转码
				loading: true,
				uploading: false,
				flag: "", //从新增或修改进入 add modify
				tableData: [], //已登记作业数据
				isDisabled: false,
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
				subject: {},
				subjectList: [],
				addData: {
					subjectId: "",
					homeworkDate: Date.now(),
					title: "",
					content: "", //作业内容
					resources: [], //作业附件
					purpose: "", //设计意图
					classInfos: [], //选择班级
					classId: "",
					checked: false,
					estimateDuration: "", //预计完成时长
					customMinutes: "", //自定义时长
					deadline: dayjs()
						.set("hour", 23)
						.set("minute", 0)
						.set("second", 0)
						.toDate(),
					realDeadline: dayjs()
						.add(1, "day")
						.toDate(), // 实际上显示的截至日期
				},
				defaultDate: new Date().getTime() - 60 * 60 * 1000, //默认截止时间
				showUnlimitedShade: false, // 是否显示不限时遮罩
				rules: {
					subjectId: [{ required: true, message: "请选择科目", trigger: "change" }],
					title: [
						{ required: true, message: "请输入作业标题", trigger: "blur" },
						{ min: 2, max: 17, message: "长度在 2 到 17 个字符", trigger: "blur" },
					],
					content: [
						{ required: true, message: "请输入作业内容", trigger: "blur" },
						{ min: 2, message: "请至少输入2个字符", trigger: "blur" },
					],
					homeworkDate: [
						{ type: "date", required: true, message: "请选择作业日期", trigger: "change" },
					],
					estimateDuration: [{ required: true, message: "请选择预计完成时长", trigger: "change" }],
					realDeadline: [{ required: true, message: "请选择作业截止时间", trigger: "change" }],
					classId: [{ required: true, message: "请选择班级", trigger: "blur" }],
					// purpose: [
					// 	{ required: true, message: '请填写设计意图', trigger: 'blur' },
					// 	{ min: 2, message: '请至少输入2个字符', trigger: 'blur' },
					// ],
				},
				selectedHwDate: "", //选择作业日期
				classHwList: [], //班级作业信息列表
				disableUpload: false,
				loading: false,
				showClassDialog: false,
				minutesList: [
					{ id: "other", label: "自定义" },
					{ id: "5", label: "5分钟" },
					{ id: "10", label: "10分钟" },
					{ id: "15", label: "15分钟" },
					{ id: "20", label: "20分钟" },
					{ id: "25", label: "25分钟" },
					{ id: "30", label: "30分钟" },
					{ id: "35", label: "35分钟" },
					{ id: "40", label: "40分钟" },
					{ id: "45", label: "45分钟" },
					{ id: "50", label: "50分钟" },
					{ id: "55", label: "55分钟" },
					{ id: "60", label: "60分钟" },
				],
			};
		},

		computed: {
			pickerOptionsStart() {
				//禁用当前日期之前的日期
				return {
					disabledDate(time) {
						return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
					},
				};
			},
			pickerOptions() {
				let self = this;
				return {
					disabledDate(time) {
						// return time.getTime() < dayjs(self.addData.homeworkDate || Date.now()).valueOf();
						return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
					},
					shortcuts: [
						{
							text: "明天",
							onClick(picker) {
								// picker.$emit("pick", new Date());
								const date = new Date();
								date.setTime(date.getTime() + 3600 * 1000 * 24);
								picker.$emit("pick", date);
							},
						},
						{
							text: "后天",
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 2 * 3600 * 1000 * 24);
								picker.$emit("pick", date);
							},
						},
						{
							text: "一周后",
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() + 7 * 3600 * 1000 * 24);
								picker.$emit("pick", date);
							},
						},
						{
							text: "不限时",
							onClick(picker) {
								picker.$emit("pick", "");
							},
						},
					],
				};
			},
		},
		watch: {
			"addData.classInfos": {
				handler(val, oldVal) {
					console.log("val--", val);
					this.addData.classId = val[0]?.id || "";
					let hiddenInput = this.$refs.hiddenInput;
					hiddenInput.focus();
					hiddenInput.blur();
				},
				deep: true,
			},
		},
		created() {},
		activated() {
			console.log("activated");
			let query = this.$route.query;
			// console.log("query--", query);
			let { id, flag, tableData } = query;
			this.tableData = tableData;
			this.flag = flag;
			if (flag == "add") {
				this.isDisabled = false;
				this.showDefaultValue();
			} else {
				this.isDisabled = true;
				this.fetchHwDetail(id);
			}
		},
		deactivated() {
			this.$destroy();
		},
		mounted() {},
		methods: {
			timeLimit() {
				if (this.addData.customMinutes < 5 || this.addData.customMinutes > 120) {
					this.addData.customMinutes = 20;
				}
			},
			dayjs,
			// 显示默认数据
			showDefaultValue() {
				let firstSubject = this.SubjectList[0] || {};
				this.currDate = dayjs().format("YYYY-MM-DD");
				let defaultValue = {
					subjectId: firstSubject.subjectId || "",
					subjectName: firstSubject.subjectName || "",
					homeworkDate: Date.now(),
					title: firstSubject.subjectName ? this.currDate + firstSubject.subjectName + "作业" : "",
				};
				this.currSubject = firstSubject.subjectName;
				Object.assign(this.addData, defaultValue);
				console.log("初始化addData", this.addData);
				this.loading = false;
			},
			// 查询作业详情
			async fetchHwDetail(id) {
				this.loading = true;
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					homeworkId: id,
				};
				const res = await getHwDetail(params);
				console.log("查详情--", res);
				this.loading = false;
				if (!res) return;
				res.classInfos = [{ id: res.classid, label: res.className }];
				res.homeworkDate = dayjs(res.homeworkDate).valueOf();
				Object.assign(this.addData, res);
				console.log("addData--", this.addData);
				this.fetchClassHwList();
			},
			// 学科改变时
			subjectChange(val) {
				this.subject = this.SubjectList.find((item) => item.subjectId == val);
				console.log("subject", { ...this.subject });
				this.currSubject = this.subject.subjectName;
				this.addData.title = this.currDate + this.currSubject + "作业";
			},
			// 作业日期改变时
			hwDateChange(val) {
				this.currDate = dayjs(val).format("YYYY-MM-DD");
				this.addData.title = this.currDate + this.currSubject + "作业";
				if (!val) return (this.addData.deadline = "");
				let date = dayjs(val)
					.add(1, "day")
					.toDate();
				this.addData.deadline = date;
				this.filterClass();
				console.log("this.addData.classInfos--000", this.addData.classInfos);
				if (this.addData.classInfos) {
					this.filterClass();
				}
			},
			//作业标题改变时
			titleChange(val) {
				this.addData.title = val;
				console.log("this.addData.title -", this.addData.title);
			},
			// 截止日期改变时
			deadlineChange(val) {
				// console.log('deadline--', val);
				if (val === "") {
					// 选择预设的'不限时' 此时值为 空字符串
					this.addData.realDeadline = "不限时";
					this.showUnlimitedShade = true;
				} else if (val === null) {
					// 此时清空了时间
					this.addData.realDeadline = "";
				} else {
					// 此时时间有值，隐藏不限时遮罩
					this.showUnlimitedShade = false;
					this.addData.realDeadline = val;
				}
			},
			estimateChange(val) {
				// console.log('预计时长--', val);
			},
			// 打开选择班级弹框
			open() {
				this.showClassDialog = true;
			},
			// 删除班级
			delClass(item, i) {
				this.addData.classInfos.splice(i, 1);
			},
			// 隐藏对话框
			hideDialog() {
				this.showClassDialog = false;
			},
			//获取班级列表
			confirm(data) {
				if (!this.addData.homeworkDate) {
					reqTip.showReqError({}, "请选择作业日期");
					return;
				}
				console.log("班级列表----", data);
				this.addData.classInfos = data;
				this.fetchClassHwList();
				this.hideDialog();
			},
			//过滤已有科目日期的班级
			filterClass() {
				let res = this.addData.classInfos?.map((item) => {
					return {
						classId: item.id,
						subjectId: this.addData.subjectId,
						homeworkDate: dayjs(this.addData.homeworkDate).format("YYYY-MM-DD"),
					};
				});
				let arr = [];
				this.tableData.forEach((item) => {
					res.forEach((item2) => {
						if (
							item.classId == item2.classId &&
							item.homeworkDate == item2.homeworkDate &&
							item.subjectId == item2.subjectId
						) {
							arr.push(item.classId);
						}
					});
				});
				this.addData.classInfos = this.addData.classInfos?.filter((item) => !arr.includes(item.id));
			},
			//查询班级作业信息列表
			async fetchClassHwList() {
				let classInfos = this.addData.classInfos;
				let classIds = classInfos.map((item) => item.id);
				let params = {
					classIds,
					homeworkDate: dayjs(this.addData.homeworkDate).format("YYYY-MM-DD"),
				};
				const res = await getClassHwList(params);
				console.log("查询班级作业信息列表--", res);
				if (!res) return;
				classInfos.forEach((item) => {
					let schoolLevel = this.ConvertSchoolLevel(item.label);
					let limitTime = schoolLevel == "xx" ? 60 : 90;
					item.subjectList = [];
					item.isOutLimit = false;
					let sum = 0;
					res.forEach((item2) => {
						if (item.label == item2.className) {
							let obj = {
								subjectName: item2.subjectName,
								estimateDuration: item2.estimateDuration,
							};
							sum += item2.estimateDuration;
							item.subjectList.push(obj);
						}
					});
					//判断当日布置作业是否超时
					if (sum > limitTime) {
						item.isOutLimit = true;
					}
				});
				this.classHwList = classInfos;
				this.selectedHwDate = dayjs(this.addData.homeworkDate).format("YYYY-MM-DD");
			},
			//新增和修改作业登记
			save() {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return console.log("验证不通过");
					console.log("验证通过");
					this.saveConfirm();
				});
			},
			// 确定登记
			saveConfirm() {
				// this.subjectChange(this.addData.subjectId);
				let ss = sessionStorage;
				let addData = this.addData;
				let classInfos = addData.classInfos.map((item) => {
					return { classid: item.id, className: item.label };
				});
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					homeworkId: addData.homeworkId,
					subjectId: addData.subjectId,
					subjectName: this.subject.subjectName || this.SubjectList[0].subjectName,
					homeworkDate: dayjs(addData.homeworkDate).format("YYYY-MM-DD"),
					title: addData.title,
					content: addData.content,
					purpose: addData.purpose,
					estimateDuration: Number(addData.estimateDuration) || Number(addData.customMinutes),
					deadline: dayjs(addData.deadline).format("YYYY-MM-DD HH:mm:ss"),
					resources: addData.resources,
					classInfos: classInfos,
				};
				if (this.flag == "add") {
					this.addHw(params);
				} else {
					this.modifyHw(params);
				}
			},

			// 新增作业登记
			async addHw(params) {
				console.log("作业登记参数--", params);
				const res = await addHwRegister(params);
				console.log("新增作业登记--", res);
				if (!res) return;
				this.goBack();
			},

			// 修改作业登记
			async modifyHw(params) {
				const res = await updateHwRegister(params);
				console.log("修改作业登记--", res);
				if (!res) return;
				this.goBack();
			},

			// 删除作业附件
			delFile(i) {
				this.addData.resources.splice(i, 1);
				let uploadInput = this.$refs.uploadInput;
				uploadInput.value = "";
			},
			//获取预览地址
			async getPreviewUrl(fid) {
				console.log("fid--", fid);

				let res = await axios.get(
					"https://filecenter.huijiaoyun.com/filecenter/upload/getAttachFileByFid/" + fid,
					{
						// dataType: "json",
						// contentType: "application/json",
					},
				);
				console.log("res预览地址", res);
				// if (err || res.code != "000000") {
				// 	err ? this.showNetworkError(err) : this.showReqError(res, "获取预览地址失败");
				// 	return;
				// }
				return res.data?.data?.previewUrl;
			},
			// 上传按钮点击事件
			uploadBtnClick() {
				this.$refs.uploadInput.click();
			},
			// 上传
			async uploadFile(index, type) {
				let uploadInput = this.$refs.uploadInput;
				console.log("uploadInput--", uploadInput.value);
				// 取消上传时，返回
				if (!uploadInput.value) return;
				this.disableUpload = true;
				this.uploading = true;

				let ss = sessionStorage;
				console.log("index--", index);
				console.log("type--", type);
				this.uploadInstance = new UploadService({
					appType: "khfw",
					userInfo: {
						userId: ss.Userlist.userId,
						platformCode: ss.Userlist.platformCode,
					},
				});
				let sourceFiles = [];
				sourceFiles = this.$refs.uploadInput.files;
				console.log("sourceFiles", sourceFiles);
				try {
					let promiseList = [],
						file_obj = {};
					for (let i = 0; i < sourceFiles.length; i++) {
						let ext = util.getFileExt(sourceFiles[i]["name"]);
						if (sourceFiles[i]["size"] == 0) {
							//大小为0的文件
							this.$message({
								message: `文件${sourceFiles[i]["name"]}是空文件,自动过滤删除`,
								type: "error",
								duration: 1000,
							});
							continue;
						}
						file_obj = {
							name: sourceFiles[i]["name"],
							// size: this.formatFileSize(sourceFiles[i].size),
							fileLength: sourceFiles[i].size,
							type: this.getExt(ext),
							source: "1",
							ext: ext,
						};
						console.log("file_obj--", file_obj);
						const fn = this.uploadInstance.upload(sourceFiles[0], {
							onProgress: (progress) => {},
						});
						promiseList.push(fn);
					}

					const resArr = await Promise.all(promiseList);
					console.log(resArr, "itemResitemRes");
					resArr.forEach((res, index) => {
						const itemRes = res.data;
						file_obj.fid = itemRes.fid;
						file_obj.length = itemRes.fileLength;
						file_obj.downloadUrl = itemRes.downloadUrl;
						if (itemRes.previewUrl) {
							file_obj.previewUrl = itemRes.previewUrl;
							this.addData.resources.push(file_obj);
							console.log("this.addData.resources", this.addData.resources);
						} else {
							// file_obj.previewUrl = itemRes.downloadUrl;
							let getPreview = setInterval(async () => {
								this.transcoding = true;
								file_obj.previewUrl = await this.getPreviewUrl(file_obj.fid);
								console.log("file_obj.previewUrl-", file_obj.previewUrl);
								if (file_obj.previewUrl) {
									this.transcoding = false;
									console.log("停止定时器判断进入");
									// this.addData.resources.push(file_obj);
									// console.log("this.addData.resources", this.addData.resources);
									clearInterval(getPreview);
									this.addData.resources.push(file_obj);
									console.log("this.addData.resources", this.addData.resources);
								}
							}, 2000);
						}
					});
				} catch (error) {
					this.$message({
						message: "上传失败",
						type: "error",
						duration: 1000,
					});
					console.log(error);
				} finally {
					this.disableUpload = false;
					this.uploading = false;
				}
			},
			getExt(ext) {
				return util.getFileType(ext);
			},

			clickUnlimitedShade() {
				this.$refs.deadline.focus();
			},
			// 返回
			goBack() {
				this.$router.back();
			},
		},
	};
</script>
<style lang="less" scoped>
	.detail {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.header {
			height: 60px;
			line-height: 48px;
			margin-bottom: 20px;
			border-bottom: 1px solid #eee;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.span1 {
				font-family: "PingFang SC Bold";
				font-size: 20px;
				color: #000;
				margin-right: 30px;
			}
			.left,
			.right {
				width: 60px;
			}
			.left {
				cursor: pointer;
				font-size: 14px;
				color: #8b8b8b;
			}
		}
		.el-form-item {
			margin-bottom: 20px;
		}
		::v-deep .hidden-input.el-input {
			position: absolute;
			top: -60px;
			left: 205px;
			.el-input__inner {
				width: 1px;
				height: 1px;
				padding: 0;
				opacity: 0;
			}
		}
		::v-deep .el-form .el-input__inner {
			// width: 100%;
			height: 32px;
			line-height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}
		.label {
			width: 300px;
		}
		.subLabel {
			width: 490px;
		}
		.upload {
			width: 100px;
			height: 32px;
			border-radius: 3px;
			background: #4991e1;
			margin-bottom: 20px;
		}
		.upload-input {
			position: relative;
			display: inline-block;
			width: 100px;
			height: 32px;
			margin-left: -100px;
			z-index: -1;
		}
		::v-deep .deadlineDate {
			height: 37px;
			line-height: 37px;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}

		.minutes-box {
			display: flex;
			font-size: 14px;
			.minutes-text {
				color: #333;
				margin-left: 10px;
				span {
					color: #999;
				}
			}
		}
		.minutes-bottom {
			color: #999;
			.minutes-red {
				color: #f74b4b;
				margin-left: 10px;
			}
		}
		.pointer {
			display: inline-block;
		}
		.transcoding {
			color: #409eff;
			margin-left: 10px;
		}
		.file-list {
			width: 100%;
			.file-item {
				width: 233px;
				height: 50px;
				line-height: 50px;
				border-radius: 4px;
				background: #f4f9ff;
				position: relative;
				display: inline-block;
				margin-right: 20px;
				margin-bottom: 10px;
				text-align: center;
				font-size: 14px;
				color: #333;
				div {
					display: flex;
					align-items: center;
					.img-icon {
						margin-left: 10px;
						width: 36px;
						height: 40px;
					}
					span {
						margin-left: 10px;
						width: 300px;
						text-align: left;
						// 省略号
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
				.del {
					position: absolute;
					top: -3px;
					right: -8px;
					cursor: pointer;
				}
			}
		}

		.class-list {
			width: 100%;

			.class-item {
				width: 120px;
				height: 50px;
				line-height: 50px;
				border-radius: 4px;
				background: #f4f9ff;
				position: relative;
				display: inline-block;
				margin-right: 20px;
				margin-bottom: 10px;
				text-align: center;
				font-size: 14px;
				color: #333;
				img {
					position: absolute;
					top: -3px;
					right: -8px;
					cursor: pointer;
				}
				.forbidden {
					cursor: not-allowed;
				}
			}
		}
		footer {
			margin-top: 30px;
			display: flex;
			justify-content: center;
		}
	}

	::v-deep .unlimited-shade {
		position: absolute;
		top: 5px;
		left: 31px;
		width: 188px;
		height: 29px;
		line-height: 29px;
		background: #fff;
		.el-input__inner {
			padding: 0;
			border: 0;
			height: 30px;
			line-height: 30px;
		}
	}
</style>
